export const CONTENT_MAX_WIDTH = '1272px';
